<template>
  <div class="NewsCenter">
    <!--头部banner-->
    <div class="banner"></div>

    <!--主体-->
    <div class="main w">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <div class="left_news">
              <span>新闻中心</span>
              <span>排行</span>
              <ul>
                <li @click="goNewsDatail(item.id)" v-for="(item,index) in allNews" :key="index">
                  <span>{{ item.title }}</span></li>
              </ul>
            </div>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="grid-content bg-purple-light">
            <!--新闻信息-->
            <div class="newsbox" v-for="(item,index) in topnewsList" :key="item.newsId" v-if="topnewsList.length > 0">
              <p><span :title="item.newsName" @click="goNewsDatail(item.id)">{{ item.title }}</span>
                <el-button type="danger" round size="mini">置顶</el-button>
              </p>
              <div class="newsinfo">
                <div class="imgbox"><img :src="item.titleImg" alt=""></div>
                <div class="info">
                  <p>时间：{{ item.createTime }}</p>
                  <div>{{ item.summary }}</div>
                  <div class="seemore" @click="goNewsDatail(item.id)">查看更多></div>
                </div>
              </div>
            </div>

            <!--新闻列表-->
            <div class="newsList">
              <ul>
                <li @click="goNewsDatail(item.id)" v-for="(item,index) in newsList" :key="item.newsId"><span
                    class="name">{{ item.title }}</span><span class="date">{{ item.createTime }}</span></li>
              </ul>
            </div>

            <div class="pagination">
              <el-pagination
                  @current-change="handleCurrentChange"
                  :current-page="pageNum"
                  :page-size="pageSize"
                  layout="total, prev, pager, next, jumper"
                  :total="total">
              </el-pagination>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>

export default {
  name: "NewsCenter",
  data() {
    return {
      form: {
        "dataIsPublish": 1,
        "informationCategoryId": "",
        "orderType": 1,
        "pageNum": 0,
        "pageSize": 0,
      },


      pageNum: 1,
      pageSize: 6,
      total: 6,

      allNews: [],
      topnewsList: null,
      newsList: [],
    }
  },
  created() {
    this.getNewsList()
    //获取排行列表
    this.getRankingList()
  },

  methods: {
    //获取排行列表
    async getRankingList() {
      try {
        let res = await this.$http.get(this.$const.Platformconsulting.GetInformatioCategoryn + 'news')
        if (res.code === 200) {
          let params = {
            "categoryId": res.data.id,
            "limitNum": 8
          }
          let list = await this.$http.post(this.$const.Platformconsulting.GetRankingList,params)
          if (list.code === 200) {
            this.allNews = list.data
          }
        }

      } catch (e) {
        // console.log(e);
      }
    },

    //获取新闻列表
    async getNewsList() {
      try {
        let res = await this.$http.get(this.$const.Platformconsulting.GetInformatioCategoryn + 'news')
        if (res.code === 200) {
          let {pageNum, pageSize} = this
          let params = JSON.parse(JSON.stringify(this.form))
          Object.assign(params, {pageNum, pageSize, informationCategoryId: res.data.id})

          let news = await this.$http.post(this.$const.Platformconsulting.GetInformatio, params)
          if (news.code === 200) {
            this.total = news.data.total
            if (this.pageNum === 1) {
              this.topnewsList = []
              this.topnewsList.push(news.data.list[0])
              this.newsList = JSON.parse(JSON.stringify(news)).data.list.splice(1, news.data.list.length - 1)
            } else {
              this.newsList = news.data.list
            }
          }
        }

      } catch (e) {
        // console.log(e);
      }
    },

    //点击跳转新闻详情页
    goNewsDatail(newsId) {
      let routeUrl = this.$router.resolve({
        name: "newsDetail",
        query: {
          newsId
        }
      });
      window.open(routeUrl.href, '_blank');
    },
    handleCurrentChange(pageNum) {
      this.pageNum = pageNum
      this.getNewsList()
    }
  }
}
</script>

<style scoped lang="scss">
.NewsCenter {
  .banner {
    width: 100%;
    min-width: 1200px;
    height: 45vh;
    background: url('~@/assets/imgs/NewsCenter/news_center_banner.png') no-repeat;
    background-size: 100% 100%;
    background-position: center;
  }

  .main {
    padding-top: 55px;

    .left_news {
      width: 290px;

      & > span {
        font-size: 20px;
        width: 100%;
        line-height: 45px;
        display: inline-block;
        background: #3868e9;
        color: #fff;
        padding: 0 20px;
        font-weight: bold;

      }

      & > span:nth-child(2) {
        background: #f5f7fa;
        color: black;
        border-bottom: 1px solid #e6e6e6;
      }

      ul {
        width: 100%;
        min-height: 100px;
        list-style: none;
        padding: 5px 20px;
        background: #f5f7fa;

        li {
          margin: 15px 0;
          position: relative;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;
          color: #666666;

          & > span {
            margin-left: 20px;
            display: inline-block;
            width: 250px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        li::before {
          content: '';
          display: table;
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background: #cccccc;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }

    .newsbox {
      width: 100%;
      margin-bottom: 20px;

      p {
        font-size: 24px;
        display: flex;
        align-items: center;
        padding-right: 30px;

        span {
          max-width: 400px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;

          &:hover {
            color: #678eed;
          }
        }

        .el-button--danger {
          background-color: transparent;
          color: #F56C6C;
          border-color: #F56C6C;
          cursor: auto;
          margin-left: 50px;
        }

        .el-button--mini, .el-button--mini.is-round {
          padding: 5px 20px;
        }
      }

      .newsinfo {
        height: 280px;
        padding: 25px 0;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #e0e0e0;

        .imgbox {
          width: 350px;
          height: 230px;
          overflow: hidden;
          border-radius: 10px;
          position: relative;

          img {
            width: 100%;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
            transition: all .5s;
          }

          img:hover {
            transform: scale(1.1);
          }
        }

        .info {
          width: calc(100% - 400px);
          position: relative;

          p {
            font-size: 12px;
            color: #999999;
          }

          div {
            margin-top: 20px;
            color: #666666;
            line-height: 3;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3; //显示行数
          }

          .seemore {
            position: absolute;
            bottom: -20px;
            right: 20px;
            color: #5a8beb;
            cursor: pointer;
          }
        }
      }
    }

    .newsList {
      min-height: 300px;
      ul {
        min-height: 100px;

        li {
          height: 60px;
          line-height: 60px;
          border-bottom: 1px dashed #e9e9e9;
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          cursor: pointer;

          .name {
            display: inline-block;
            width: 650px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .name:hover {
            color: #3867e9;
          }
        }
      }
    }

    .pagination {
      margin: 20px 0;
      text-align: center;
    }
  }
}
</style>
